import {Component, HostBinding} from '@angular/core';
import {GlobalEventService} from "../../shared/services/global-event/global-event.service";

@Component({
  selector: 'app-donation-menu',
  template: `
    <div class="pay-btn-box">
      <a class="pay-btn type-kakao" [routerLink]="['/options', 'kakaopay']">

        <i class="ic ic-kakao"></i>
        <div class="txt">카카오페이</div>
      </a>
    </div>

    <!-- div class="pay-btn-box">
      <a href="#none" class="pay-btn type-npay">
        <i class="ic ic-npay"></i>
        <div class="txt">네이버 페이</div>
      </a>
    </div -->

    <!-- div class="pay-btn-box">
      <a href="#none" class="pay-btn type-toss">
        <i class="ic ic-toss"></i>
        <div class="txt">토스</div>
      </a>
    </div -->

    <!-- div class="pay-btn-box">
      <a href="#none" class="pay-btn type-paypal">
        <i class="ic ic-paypal"></i>
        <div class="txt">PayPal</div>
      </a>
    </div -->
  `,
})
export class DonationMenuComponent {
  @HostBinding('class') class = 'pay-box';

}
